<template>
    <div class="min_box">
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
            <div class="search-group flex">
                <a-input  v-model="search.company" placeholder="请输入关键词称搜索"  class="search-input" allowClear />
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
                <a-button   class="top_btn" @click="empty">重置</a-button>
            </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="times" slot-scope="text, record">
                <a @click="openTimes(record)">{{text.times}}</a>
            </span>
          <span slot="sub_times" slot-scope="text, record">
                <a @click="openSub(record)">{{text.sub_times}}</a>
            </span>
        </a-table>
      <a-modal :footer="null" v-model="timesVisible"   on-ok="handleOk" >
        <template slot="title"><div v-html="timesitle"></div>  </template>
        <template slot="footer">  </template>
        <a-table style="max-height: 60vh;overflow: auto" :pagination='false' :columns="[ { title: '点击时间', dataIndex: 'create_time',  key: 'create_time',   },]" :data-source="timesData">
        </a-table>
      </a-modal>

      <a-modal :footer="null" v-model="subVisible"   on-ok="handleOk" >
        <template slot="title"><div v-html="subitle"></div>  </template>
        <template slot="footer">  </template>
        <a-table style="max-height: 60vh;overflow: auto" :pagination='false' :columns="[ { title: '点击时间', dataIndex: 'create_time',  key: 'create_time',   },{ title: '需求内容', dataIndex: 'service_text',  key: 'service_text',   }]" :data-source="subData">
        </a-table>
      </a-modal>
    </div>

</template>

<script>
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

        {
            title: "客户名称",
            key: "company",
            dataIndex: "company",
        },
        {
            title: "点“我要代运营”次数",
            key: "times",
            scopedSlots: {customRender: "times"}
        },{
        title: "点“确认”次数",
        key: "sub_times",
        scopedSlots: {customRender: "sub_times"}
      },{
        title: "需求内容",
        key: "service_text",
        dataIndex: "service_text",
      }
    ];
    export default {
        name: 'index',
        data() {
            return {
              timesitle:"",
              timesVisible:false,
              timesData:[],


              subitle:"",
              subVisible:false,
              subData:[],
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                name:"",
                search: {
                  company: "",
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Operate"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            empty(){
                this.search.name=""
                this.getList()
            },
            handleChange(pagination, filters, sorter) {
            },
            exportList(){
                API.service.EXPORT({name:this.name ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },

            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            gotoStatistics(row){
                this.$router.push(`/DataStatistics/WebStatistics?id=${row.id}&name=${row.name}&type=industry`)
            },
          openTimes(row){
            API.service.openTimes({a_customer_id:row.a_customer_id }).then(res => {
              this.timesitle=`<h1>${row.company}<span style="font-size: 12px;font-weight: 400">  -点击“我要代运营”详情</span></h1>`
              this.timesData=res.data.data
              this.timesVisible=true
            })
          },

          openSub(row){
            API.service.openSub({a_customer_id:row.a_customer_id }).then(res => {
              this.subitle=`<h1>${row.company}<span style="font-size: 12px;font-weight: 400">  -点击“确认“详情</span></h1>`
              this.subData=res.data.data
              this.subVisible=true
            })
          }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .min_box{width: 60%}

</style>
